import { motion } from "framer-motion";

const STATS = [
  { value: "10+", label: "Years delivering" },
  { value: "50+", label: "Integrations shipped" },
  { value: "99.9%", label: "Uptime targets" },
  { value: "24/7", label: "Global operations" },
];

const StatsStrip = () => {
  return (
    <section
      aria-label="Company stats"
      data-testid="stats-strip"
      className="relative border-y border-[rgba(244,234,222,0.10)] bg-[rgba(244,234,222,0.02)]"
    >
      <div className="container-narrow grid grid-cols-2 md:grid-cols-4 divide-x divide-[rgba(244,234,222,0.08)]">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.45, delay: i * 0.06, ease: [0.2, 0.8, 0.2, 1] }}
            className="py-8 sm:py-10 px-4 sm:px-6 first:pl-0 last:pr-0"
          >
            <div className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#F4EADE]">
              {s.value}
            </div>
            <div className="mt-2 font-mono text-[11px] sm:text-xs uppercase tracking-[0.18em] text-[#B9AFA6]">
              {s.label}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default StatsStrip;
